export enum Web3AccountInfoStatus {
    CONNECTED = 'connected'
}
